
import { cx } from "@/lib/utils/cx"
import type { EstimateStatus } from "@/lib/api/types"

interface StatusBadgeProps {
  status:     EstimateStatus
  className?: string
  size?:      "sm" | "md"
}

/** The one place a status has a word and a colour — the board, the badge and
 *  the task screen's stage strip all read from here. */
export const STATUS_CFG: Record<EstimateStatus, { label: string; dot: string; bg: string; text: string; ring: string }> = {
  Draft:      { label: "Draft",       dot: "bg-zinc-400",    bg: "bg-zinc-50",     text: "text-zinc-600",    ring: "ring-zinc-200"   },
  Loading:    { label: "Loading",     dot: "bg-orange-400",  bg: "bg-orange-50",   text: "text-orange-700",  ring: "ring-orange-200" },
  Pending:    { label: "Pending",     dot: "bg-amber-400",   bg: "bg-amber-50",    text: "text-amber-700",   ring: "ring-amber-200"  },
  Confirmed:  { label: "Confirmed",   dot: "bg-teal-400",    bg: "bg-teal-50",     text: "text-teal-700",    ring: "ring-teal-200"   },
  InProgress: { label: "In Progress", dot: "bg-blue-400",    bg: "bg-blue-50",     text: "text-blue-700",    ring: "ring-blue-200"   },
  Scheduled:  { label: "Scheduled",   dot: "bg-sky-400",     bg: "bg-sky-50",      text: "text-sky-700",     ring: "ring-sky-200"    },
  Completed:  { label: "Completed",   dot: "bg-emerald-500", bg: "bg-emerald-50",  text: "text-emerald-700", ring: "ring-emerald-200"},
  Declined:   { label: "Declined",    dot: "bg-red-400",     bg: "bg-red-50",      text: "text-red-600",     ring: "ring-red-200"    },
}

export function StatusBadge({ status, className, size = "sm" }: StatusBadgeProps) {
  const c = STATUS_CFG[status] ?? STATUS_CFG.Draft
  return (
    <span
      className={cx(
        "inline-flex items-center gap-1.5 font-medium ring-1 ring-inset leading-none",
        c.bg, c.text, c.ring,
        size === "sm" ? "px-2 py-1 rounded-lg text-[10px]" : "px-2.5 py-1.5 rounded-xl text-[11px]",
        className,
      )}
    >
      <span className={cx("size-1.5 rounded-full shrink-0", c.dot)} />
      {c.label}
    </span>
  )
}
